export const COOKIE_CONSENT_KEY = 'fair_cookie_consent';

export type CookieConsentValue = 'accepted' | 'rejected' | 'cancelled';

export function getCookieConsent(): CookieConsentValue | null {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(COOKIE_CONSENT_KEY);
  return value === 'accepted' || value === 'rejected' || value === 'cancelled' ? value : null;
}

export function setCookieConsent(value: CookieConsentValue) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
}
